import { Theme } from 'src/helpers/Constants';

export const getSiteName = (siteName?: string): Theme => (siteName === 'wagnwash' ? 'wnw' : 'psp');
